(function () {
  "use strict";

  const DBG = true;
  const VERSION = "v9-position-tuned";
  const log = (...a) => DBG && console.log("[SDT]", ...a);

  log("script loaded", VERSION);

  function initSafeDry(root) {
    if (!root || root.dataset.sdtInit === "1") return;
    root.dataset.sdtInit = "1";
    log("init on", root);

    const steps = root.querySelectorAll("[data-phase]");
    if (!steps.length) return;

    /* Phase observer: which step is in the viewport reading zone */
    const phaseObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const phase = entry.target.getAttribute("data-phase");
            if (phase) root.setAttribute("data-phase", phase);
          }
        }
      },
      { rootMargin: "-25% 0px -50% 0px", threshold: 0 }
    );

    /* Reveal observer: fades each step on first sight */
    const revealObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            revealObserver.unobserve(entry.target);
          }
        }
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.15 }
    );

    steps.forEach((el) => {
      phaseObserver.observe(el);
      revealObserver.observe(el);
    });

    /* Desktop-only scroll-driven bag animation.
       Note: we intentionally don't gate on prefers-reduced-motion here —
       the bag's scroll-linked travel is a 1:1 response to user input,
       not an auto-playing animation, so it's fine under RM guidelines.
       Only the per-step fade-in (CSS) respects the preference. */
    const bagWrap = root.querySelector(".td-sdt__bag-wrap");
    log("bagWrap found?", !!bagWrap);
    if (!bagWrap) {
      log("bailing: no bagWrap element");
      return;
    }

    const mq = window.matchMedia("(min-width: 900px)");
    log("desktop breakpoint matches?", mq.matches, "window width:", window.innerWidth);

    /* Drive the bag from the sticky track's own lifetime:
       0 when the desktop grid first hits the viewport top,
       1 when the grid's bottom reaches the viewport bottom.
       This guarantees a full top-to-bottom descent during the
       entire visible sticky window, regardless of step padding. */
    const grid = root.querySelector(".td-sdt__grid");
    const sticky = root.querySelector(".td-sdt__sticky");

    let rafId = 0;
    let running = false;
    let frameCount = 0;

    const tick = () => {
      if (!running) return;

      const viewH = window.innerHeight || document.documentElement.clientHeight;
      const trackRect = (grid || root).getBoundingClientRect();
      const stickySpan = Math.max(1, trackRect.height - viewH);
      const stickP = Math.min(1, Math.max(0, -trackRect.top / stickySpan));

      /* Resolve the initial tilt early so the bag is upright for most of
         the reading journey, but keep the vertical descent continuous. */
      const rp = Math.min(1, stickP / 0.18);
      const rotate = 42 * (1 - rp * rp);

      /* Large linear travel so the movement is obvious:
         near the top of the viewport at step 01, near the bottom by step 06. */
      const yStart = -viewH * 0.32;
      const yEnd = viewH * 0.30;
      const y = yStart + (yEnd - yStart) * stickP;

      const scale = 1 + Math.sin(stickP * Math.PI) * 0.02;

      bagWrap.style.transform =
        "translate3d(0," + y.toFixed(1) + "px,0) rotate(" +
        rotate.toFixed(2) + "deg) scale(" + scale.toFixed(3) + ")";

      frameCount++;
      if (frameCount === 1 || frameCount === 60 || frameCount % 240 === 0) {
        const stickyTop = sticky ? sticky.getBoundingClientRect().top : null;
        log("tick frame=" + frameCount,
          "stickP=" + stickP.toFixed(3),
          "y=" + y.toFixed(1),
          "rotate=" + rotate.toFixed(1),
          "trackTop=" + trackRect.top.toFixed(1),
          "stickyTop=" + (stickyTop === null ? "na" : stickyTop.toFixed(1)));
      }

      rafId = requestAnimationFrame(tick);
    };

    const start = () => {
      if (running) return;
      if (!mq.matches) { log("start aborted: below desktop breakpoint"); return; }
      running = true;
      bagWrap.style.willChange = "transform";
      log("rAF loop started");
      rafId = requestAnimationFrame(tick);
    };

    const stop = () => {
      running = false;
      cancelAnimationFrame(rafId);
      bagWrap.style.transform = "";
      bagWrap.style.willChange = "";
    };

    if (mq.matches) start();
    if (mq.addEventListener) {
      mq.addEventListener("change", (e) => (e.matches ? start() : stop()));
    } else if (mq.addListener) {
      mq.addListener((e) => (e.matches ? start() : stop()));
    }
  }

  function initAll() {
    document.querySelectorAll(".td-sdt").forEach(initSafeDry);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target.querySelector(".td-sdt");
    if (root) {
      delete root.dataset.sdtInit;
      initSafeDry(root);
    }
  });
})();
